import { CategoryDto } from './category.dto';
import { Facility } from './facility';

export class Category {
    readonly id: string | null;
    readonly name: string;
    readonly description: string;
    readonly public: boolean;
    readonly active: boolean;
    readonly productCount: number;
    readonly chainStore: Facility | null;
    readonly featured: boolean;

    constructor(dto: CategoryDto) {
        this.id = dto.id ?? null;
        this.name = dto.name;
        this.description = dto.description;
        this.public = dto.public;
        this.active = dto.active;
        this.productCount = dto.productCount;
        this.chainStore = dto.chainStore ?? null;
        this.featured = dto.featured;
    }
}
